import { IGetterFn } from '@/store/types';

// 迁移环境
export const getMigrateEnvs: IGetterFn = () => {
  return [
    { text: '开发环境', value: 'dev', color: '' },
    { text: '测试环境', value: 'test', color: 'blue' },
    { text: '正式环境', value: 'prod', color: 'red' },
  ];
};

// 专案迁移类型
export const getDesignTypes: IGetterFn = () => {
  return [
    { text: '平台专案', value: 2 },
    { text: '个人设计', value: 3 },
    { text: '杂志', value: 4 },
  ];
};

// 静态材质包的状态
export const getTextureStatuses: IGetterFn = () => {
  return [
    { text: '校验数据一致', value: '', color: '' },
    { text: '待更新文件', value: '', color: 'blue--text' },
    { text: '最新版文件', value: '', color: 'green--text' },
    { text: '待删除文件', value: '', color: 'orange--text' },
    { text: '找不到文件', value: '', color: 'red--text' },
  ];
};

// 灯光配置的状态
export const getIesStatuses: IGetterFn = () => {
  return [
    { text: '无需同步', value: '', color: '' },
    { text: '文件不存在!', value: '', color: 'red--text' },
  ];
};

/**
 * 迁移类型列表
 *
 * 需要注意的地方是，有几个文件的 migrateType 是硬编码进代码里的，需要跟 value 字段值保持一致
 * 当 value 值被修改时，以下几个文件里的 migrateType 也要同步修改：
 *  1. @/views/data/common/List.vue
 *  2. @/views/data/output/Form.vue 里的 `showCodes` 和 `showPaths` 计算属性
 *  3. @/views/data/migration/task/excel.ts
 *  4. @/store/data/migration/action.ts 里的 `queryTaskDetail`
 *
 * @Field text      迁移类型的中文名称
 * @Field value     迁移类型
 * @Field dto       '迁移任务详情'接口返回结果里, 对应的列表字段(数据迁入和迁出模块)
 * @Field checkUrl  '查询当前环境不存在的品牌列表(品牌检查)'接口地址（数据迁入模块）
 * @Field postUrl   '创建迁出任务'接口地址（数据迁出模块）
 * @Field hide      不在下拉框里显示（数据迁出模块）
 * @Field search    用于拼音搜索(简拼或全拼)
 */
export const getMigrateTypes: IGetterFn = () => {
  return [
    {
      text: '物品，零件，模块，道具',
      value: 'modelitem',
      dto: 'modelTypeItemDtos',
      // postUrl: '/migration/output/item/models',
      postUrl: '/v1/migration/output/item/models',
      // checkUrl: '/migrate/modelItems/check',
      checkUrl: '/v1/migration/modelItems/check',
      search: ['WuPin', 'LingJian', 'MoKuai', 'DaoJu'],
      hide: false,
    },
    {
      text: '材料',
      value: 'materialitem',
      dto: 'materialTypeItemDtos',
      // postUrl: '/migration/output/item/materials',
      postUrl: '/v1/migration/output/item/materials',
      // checkUrl: '/migrate/materialItems/check',
      checkUrl: '/v1/migration/materialItems/check',
      search: ['CaiLiao'],
      hide: false,
    },
    {
      text: '材质',
      value: 'materialinstance',
      dto: 'materialInstanceDtos',
      // postUrl: '/migration/output/ueitem/materialinstances',
      postUrl: '/v1/migration/output/ueitem/materialinstances',
      checkUrl: '',
      search: ['CaiZhi'],
      hide: false,
    },
    {
      text: '底材',
      value: 'basicmaterial',
      dto: 'materialTypeItemDtos',
      // postUrl: '/migration/output/item/basicmaterials',
      postUrl: '/v1/migration/output/item/basicmaterials',
      checkUrl: '',
      search: ['DiCai'],
      hide: false,
    },
    {
      text: '角色',
      value: 'actor',
      dto: 'actorDtos',
      // postUrl: '/migration/output/ueitem/actors',
      postUrl: '/v1/migration/output/ueitem/actors',
      checkUrl: '',
      search: ['JueSe', 'JiaoSe'],
      hide: false,
    },
    {
      text: '模型',
      value: 'mesh',
      dto: 'meshDtos',
      // postUrl: '/migration/output/ueitem/meshes',
      postUrl: '/v1/migration/output/ueitem/meshes',
      checkUrl: '',
      search: ['MoXing'],
      hide: false,
    },
    {
      text: '导航',
      value: 'navigation',
      dto: 'navigationDtos',
      // postUrl: '/migration/output/navigation',
      postUrl: '/v1/migration/output/navigation',
      checkUrl: '',
      search: ['DaoHang'],
      hide: false,
    },
    {
      text: '专案',
      value: 'design',
      dto: 'designProjectGroups',
      // postUrl: '/migration/output/design',
      postUrl: '/v1/migration/output/design',
      // checkUrl: '/migrate/design/check',
      checkUrl: '/v1/migration/design/check',
      search: ['ZhuanAn'],
      hide: false,
    },
    {
      text: '专案展示',
      value: 'designshow',
      dto: 'designProjectShows',
      postUrl: '/v1/migration/output/designshow',
      checkUrl: '/v1/migration/designshow/check',
      search: ['ZhuanAnZhanShi'],
      hide: false,
    },
    {
      text: '样板间',
      value: 'blankroom',
      dto: 'blankRoom',
      // postUrl: '/migration/output/blankroom',
      postUrl: '/v1/migration/output/blankroom',
      checkUrl: '',
      search: ['YangBanJian'],
      hide: false,
    },
    // {
    //   text: '副本',
    //   value: 'roominstance',
    //   dto: 'roomInstanceDtos',
    //   postUrl: '/migration/output/roominstance',
    //   checkUrl: '',
    //   search: ['FuBen'],
    //   hide: false,
    // },
    // {
    //   text: '开放世界',
    //   value: 'openworld',
    //   dto: 'openWorldDtos',
    //   postUrl: '/migration/output/openworld',
    //   checkUrl: '/migrate/openworld/check',
    //   search: ['KaiFangShiJie'],
    //   hide: false,
    // },
    {
      text: '地图',
      value: 'map',
      dto: 'mapNames',
      // postUrl: '/migration/output/map',
      postUrl: '/v1/migration/output/map',
      checkUrl: '',
      search: ['DiTu'],
      hide: false,
    },
    {
      text: '过滤项',
      value: 'filter',
      dto: 'filterItemMigrationDto',
      // postUrl: '/migration/output/filter',
      postUrl: '/v1/migration/output/filter',
      checkUrl: '',
      search: ['GuoLvXiang'],
      hide: false,
    },
    {
      text: '静态贴图包',
      value: 'statictextures',
      dto: 'staticTextureBundlesDto',
      // postUrl: '/migration/output/ueitem/statictexture',
      postUrl: '/v1/migration/output/ueitem/statictexture',
      search: ['JingTaiTieTuBao'],
      checkUrl: '',
      hide: false,
    },
    {
      text: '硬装产品',
      value: 'digitalproducts',
      dto: 'digitalProducts',
      postUrl: '/v1/migration/output/digitalproducts',
      search: ['YingZhuangChanPin'],
      checkUrl: '',
      hide: false,
    },
    {
      text: '型材和型材产品（老）',
      value: 'sweepsections',
      dto: 'sweepSections',
      postUrl: '/v1/migration/output/sweepsections',
      search: ['XingCai', 'XingCaiChanPin'],
      checkUrl: '',
      hide: false,
    },
    {
      text: '型材',
      value: 'sectionbar',
      dto: 'sectionBars',
      postUrl: '/v1/migration/output/sectionbar',
      search: ['XingCai'],
      checkUrl: '',
      hide: false,
    },
    {
      text: '型材产品',
      value: 'sectionproduct',
      dto: 'sectionProducts',
      postUrl: '/v1/migration/output/sectionproduct',
      checkUrl: '/v1/migration/modelItems/check',
      search: ['XingCaiChanPin'],
      hide: false,
    },
    {
      text: '灯光配置',
      value: 'ies',
      dto: '',
      postUrl: '',
      search: ['DengGuangPeiZhi'],
      hide: true,
    },
  ];
};
